
import Styled from 'styled-components'

export const BackToTheTop = Styled.div`
position: fixed;
right: 0px;
bottom: 15px;
z-index: 1035;
background: #7f7f7f;
color: #fff;
width: 112px;
padding: 3px 10px 3px 5px;
cursor: pointer;
text-align: center;
display:flex;

svg{
    display: flex; 
    position: absolute;
    margin-top: -2px;
    height: 100%;
}
p{
    margin: 4px 0;
    line-height: 1;
    color: #ddd;
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    
}
`
